import * as z from "zod";

export const getAccountBillingSettings = {
  name: "getAccountBillingSettings" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    settings: z
      .object({
        unifiedBillingEnabled: z.boolean(),
        targetBillingDay: z.number().int().min(1).max(28),
      })
      .nullable(),
  }),
};
